import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "store-detail-map",
  class StoreDetailMap extends WYATTElement {
    constructor() {
      super();

      this.mapContainer = this.querySelector("[data-map]");
      this.markerTemplate = this.querySelector("[data-marker-template]");

      this.setup();
    }

    get position() {
      const { address } = this.config.store || {};

      if (!address?.latitude || !address?.longitude) {
        return null;
      }

      return {
        lat: address.latitude,
        lng: address.longitude,
      };
    }

    setup() {
      if (!this.position) {
        return;
      }

      this.initMap();
    }

    async initMap() {
      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } =
        await google.maps.importLibrary("marker");

      this.map = new Map(this.mapContainer, {
        zoom: 15,
        center: this.position,
        mapId: this.config.id,
      });

      const markerContent =
        this.markerTemplate?.content.firstElementChild?.cloneNode(true);

      this.marker = new AdvancedMarkerElement({
        map: this.map,
        position: this.position,
        title: this.config.store.name,
        content: markerContent,
      });
    }
  },
);
